import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroClock, heroTag } from '@ng-icons/heroicons/outline';

type ConversationPreferenceItem = {
  label: string;
  path: string;
  icon: string;
};

const CONVERSATION_PREFERENCE_ITEMS: readonly ConversationPreferenceItem[] = [
  {
    label: 'Labels',
    path: '/conversas/preferencias/labels',
    icon: 'heroTag',
  },
  {
    label: 'SLA',
    path: '/conversas/preferencias/sla',
    icon: 'heroClock',
  },
];

@Component({
  selector: 'app-conversation-preferences-page',
  imports: [NgIcon, RouterLink, RouterLinkActive, RouterOutlet],
  providers: [provideIcons({ heroClock, heroTag })],
  templateUrl: './conversation-preferences.page.html',
  styleUrl: './conversation-preferences.page.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationPreferencesPage {
  protected readonly preferenceItems = CONVERSATION_PREFERENCE_ITEMS;
  protected readonly preferencePathPrefix = '/conversas/preferencias/';
}
